import { z } from "zod";

export const FeedLensSchema = z.enum([
    "best-match",
    "nearby",
    "needs-home-soon",
]);

export type FeedLens = z.infer<typeof FeedLensSchema>;
